// extracted by mini-css-extract-plugin
export default {"vertical-icon":"DealCard_vertical-icon__TBDak"};